 
 
 
import React from "react"

function VideoSimple(props) {
   
   
  return (
     
    <video  className={props.className} controls src={props.src} autoPlay={props.autoplay}   muted={props.muted} loop={props.loop}  />

  );
}

export default VideoSimple;
